module.exports = __webpack_public_path__ + "h5/img/noGood.45177db1.png";